module.exports = __webpack_public_path__ + "media/images/icons/google-podcast-lg-a2a3b48aa0ab09d6e09734a2c96c9333.svg";